import { AvatarProps } from '@ui-system/interfaces-avatar';

const defaultProps: Partial<AvatarProps> = {
  shape: 'rounded',
  size: 'giant',
  variant: 'circle',
};
export default defaultProps;
